import { abbreviateNumber } from '@gonfalon/format/abbreviateNumber';

import { AggregationType, Granularity, type SeriesData } from '../../../types';

export type UsageChartType = 'bar' | 'line';

type TimeAxisLabelOptions = {
  condenseLabels?: boolean;
};

type ValueAxisOptions = {
  max?: number;
};

export function getUsageChartType(aggregationType: AggregationType, granularity: Granularity): UsageChartType {
  return aggregationType === AggregationType.INCREMENTAL ||
    aggregationType === AggregationType.AVERAGE ||
    granularity === Granularity.MONTHLY
    ? 'bar'
    : 'line';
}

export function getUsageTimeAxisLabelFormat(
  granularity: Granularity,
  { condenseLabels = false }: TimeAxisLabelOptions = {},
): string | undefined {
  if (granularity === Granularity.MONTHLY) {
    return '{MMM}';
  }
  return condenseLabels ? undefined : '{MMM} {d}';
}

export function formatUsageValueAxisLabel(value: number): string {
  return abbreviateNumber(value);
}

export function getUsageValueAxisOptions({ max }: ValueAxisOptions = {}) {
  return {
    type: 'value' as const,
    scale: true,
    axisLabel: {
      formatter: formatUsageValueAxisLabel,
    },
    min: 0,
    ...(max && { max, minInterval: max === 1 ? 0.25 : undefined }),
  };
}

export function toUsageChartData(series: SeriesData) {
  return series.map((item) => {
    const value: [number, number | null] = [item.time, item.value];
    return {
      value,
      ...(item.primaryContext && { primaryContext: item.primaryContext }),
    };
  });
}
